<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap >
      <v-flex sm12>
        <div class="col-md-12" style="float: right;">
          <v-dialog v-model="modaltreinamento.dialog" persistent max-width="500px">
            <v-btn color="primary" dark slot="activator">Novo Treinamento</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">Cadastro de Treinamentos</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                      label="Nome"
                      v-model="treinamento.name"
                      :rules="[rules.required]"
                      required></v-text-field>
                    </v-flex>            
                    <v-flex xs12>
                     <div class="v-input v-textarea v-text-field v-text-field--enclosed v-text-field--outline">
                      <div class="v-input__control">
                        <div class="v-input__slot">
                          <div class="v-text-field__slot">
                            <label aria-hidden="true" class="v-label" style="left: 0px; right: auto; position: absolute;">Descrição</label>
                            <textarea tabindex="0" aria-label="Description" rows="5" v-model="treinamento.description"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-flex>                             
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="modaltreinamento.dialog = false">Fechar</v-btn>
              <v-btn color="blue darken-1" flat @click="creatTreinamento()">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-flex>

    <!-- tabela de treinamentos -->  
    <v-flex lg12>
      <vue-good-table
      :columns="columns"
      :rows="trainings"
      @on-cell-click="onCellClick"
      :pagination-options="{
      enabled: true,
      nextLabel: 'next',
      prevLabel: 'prev',
      rowsPerPageLabel: 'Registros por página',
      ofLabel: 'of',
      allLabel: 'Todos',
    }"
    styleClass="vgt-table bordered vgt-table condensed">
  </vue-good-table>
</v-flex>


<v-flex>
  <v-dialog v-model="modaledittreinamento.dialog" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">Editando Treinamento</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                    label="Nome"
                    v-model="dados_trainings.name"
                    :rules="[rules.required]"
                    required></v-text-field>
                  </v-flex>            
                  <v-flex xs12>
                    <div class="v-input v-textarea v-text-field v-text-field--enclosed v-text-field--outline">
                      <div class="v-input__control">
                        <div class="v-input__slot">
                          <div class="v-text-field__slot">
                            <textarea tabindex="0" aria-label="Description" rows="5" v-model="dados_trainings.description"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <v-switch
                    label="Ativo"
                    v-model="dados_trainings.active"
                    ></v-switch>  
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="modaledittreinamento.dialog = false">Fechar</v-btn>
        <v-btn color="blue darken-1" flat @click="updateTreinamento()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-flex>  

<v-flex>
  <v-dialog v-model="modalcertificado.dialog" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">Upando verso do certificado</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <input type="file" id="file" ref="file" accept="pdf/*" v-on:change="handleFileUpload()"/>
                  </v-flex>            
                </v-layout>
              </v-container>
            </v-card-text>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="modalcertificado.dialog = false">Fechar</v-btn>
        <v-btn color="blue darken-1" flat @click="upAssinaturasVerso()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-flex>  

</v-layout>
</v-container>    

</template>

<script>
import {http, httpLogin} from '../../backend/vue-axios/axios';
import swal from 'sweetalert';
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      file: '',
      search: '',
      trainings: [],
      dados_trainings: [],
      columns: [
      {
        label: 'Nome',
        field: 'name',
        filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Informe o nome do treinamento', // placeholder for filter input
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
          },
        },
        {
          label: 'Descrição',
          field: 'description',
          filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Informe a descrição do treinamento', // placeholder for filter input
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
            },
          },        
          {
            label: 'Editar',
            field: 'btn',
            html: true,
          },
          {
            label: 'Verso Capa',
            field: 'btncertificado',
            html: true,
          }
          ],

          treinamento: {
            name: '',
            description: '',
            active: '', 
          },

          modaltreinamento: {
            dialog: false
          },           
          modaledittreinamento: {
            dialog: false
          },              
          modalcertificado: {
            dialog: false
          },    
          rules: {
            required: (value) => !!value || 'Campo Obrigtório.',
          },
        };
      },

      mounted () {
        this.buscaTreinamentos();
      }, 

      methods: {

        onCellClick(params)
        {
          //console.log(params)

          if(params.column.field == 'btncertificado')
          {
            this.clickAddCertficado(params)
          }else{
            this.clickTd(params)
          } 
          
        },

        handleFileUpload(){
          this.file = this.$refs.file.files[0];
          let reader  = new FileReader();
          reader.addEventListener("load", function () {
          }.bind(this), false);

          if( this.file ){
            if ( /\.(pdf)$/i.test( this.file.name ) ) {
              reader.readAsDataURL( this.file );
            }
          }
        },      


        buscaTreinamentos() {
          http.get('trainings')
          .then(response => {
           // console.log(response.data);
           this.trainings = response.data;
           
           for (var traning in this.trainings) {
            this.trainings[traning].btn = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">edit</i></div></button>'
            this.trainings[traning].btncertificado = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">assignment</i></div></button>'
          }

        })
          .catch(error => {
            console.log();
          });
        },


        creatTreinamento() {

        http.post('trainings', {
            name: this.treinamento.name,
            description: this.treinamento.description,
          })
          .then(response => {

          this.modaltreinamento.dialog = false;

          this.buscaTreinamentos();

          swal({
            title: "Treinamento!",
            text: "cadastrado com sucesso!",
            icon: "success",
            timer: 1000,
            button: false

          });
        })
          .catch(error => {
            this.errors = [];
          });
        },

        clickTd(params)
        {
          if(params.row.id == null || params.row.id == '')
          {
            swal({
              title: "Não",
              text: "foi possível editar o cadastro!",
              icon: "success",
              timer: 1000,
              button: false

            });
          }  
          this.modaledittreinamento.dialog = true;

          let id_treinamento = params.row.id;
          let token = this.$localStorage.get('token')

          let data = {
            id: params.row.id,
            name: params.row.name,
            description: params.row.description,
            active: params.row.active,

          }

          this.dados_trainings = data;
        },
        

        clickAddCertficado(params)
        {

          if(params.row.id == null || params.row.id == '')
          {
            swal({
              title: "Não",
              text: "foi possível editar o cadastro!",
              icon: "success",
              timer: 1000,
              button: false

            });
          }  
          this.modalcertificado.dialog = true;
          let data = {
            id: params.row.id,
            name: params.row.name,
            description: params.row.description,
            active: params.row.active,
          }

          this.dados_trainings = data;
        },

        updateTreinamento()
        {
          http.put('trainings/' + this.dados_trainings.id, {
            name: this.dados_trainings.name,
            description: this.dados_trainings.description,
            active: this.dados_trainings.active,
          })
          .then(response => {

            this.buscaTreinamentos();

            swal({
              title: "Treinamento!",
              text: "atualizado com sucesso!",
              icon: "success",
              timer: 1000,
              button: false

            });

            this.modaledittreinamento.dialog = false;
            this.dados_trainings.push(response.data);


          })
          .catch(error => {
            this.errors = [];
          });

          this.buscaTreinamentos();
        },

        upAssinaturasVerso(params)
        {
          let id_traning = this.dados_trainings.id;
          var data = new FormData();
          data.append('backcertificate', this.file);
          http.post('/trainings/'+ id_traning +'/backcertificate', data ,{
            headers: {
              'Content-Type': 'multipart/form-data; application/x-www-form-urlencoded; charset=UTF-8'
            }
          })
          .then(response => {
            swal({
              title: "Treinamento!",
              text: "atualizado com sucesso!",
              icon: "success",
              timer: 1800,
              button: false

            });
            this.$refs.file.value = null;
            this.modalcertificado.dialog = false;
            this.buscaTreinamentos();
          })
          .catch(e => {
            console.log(e);
          });
          this.modalcertificado.dialog = false
        },

      }
    };
    </script>
    <style scoped lang="css">
    .custom-class{
      background-color: #b3d4fc!important
    }
    </style>



// WEBPACK FOOTER //
// src/components/treinamentos/Treinamentos.vue